import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-arrow",
  "use": "down-arrow-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\" id=\"down-arrow\"><polygon points=\"8.97 0 5.01 3.9 1 0.03 0 1.03 4.96 6 10 1.08 8.97 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol